import React, { useState, useEffect, useCallback  } from "react"
import { useGlobalState } from "../contexts/GlobalStateContext"
import axios from 'axios'

const Home = () => {
    const { t, API_PATH, fetchTempData, userData, setUserData, setActiveComponent, setAlphaRecruitUrlParams } = useGlobalState()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    const params = new URLSearchParams(window.location.search)
    const res_id = params.get("res_id")

    const isUUIDLength = (value) => typeof value === "string" && value.length === 36;

    useEffect(() => {
        let isMounted = true;
    
        if (isMounted) {
          if (res_id && isUUIDLength(res_id)) {
            setAlphaRecruitUrlParams({ res_id: res_id});
            // Fetch user data
            axios.get(API_PATH + "fetch-loga3-applicants-data.php", {
                params: {
                  res_id: res_id,
                },
              })

              .then((res) => {
                fetchTempData(res_id);
                if (res.data["error"]){
                  setError(res.data["error"]);
                } else if (!res.data.applicant) {
                  setError(t("Home.alert_user_not_found"));
                } else {
                  setUserData(res.data.applicant);
                }
                
              })
              .catch((e) => {
                setError(e.message);
              });
    
            setLoading(false);
          } else {
            setError(t("Home.alert_user_not_found"));
          }
        }

        return () => {
          isMounted = false;
        };
      }, [res_id, setAlphaRecruitUrlParams, t, API_PATH, fetchTempData, setUserData]);

    const createParticipantInDB = useCallback(() => {
        userData && axios.get(API_PATH + 'create-participant.php', {
          params: {
            method: 'create',
            res_id: res_id,
            name: userData.name,
            company: userData.company,
            branch: userData.branch
          },
        }
       )
            .then(res => { setUserData(prevState => ({ ...prevState, participant_id: res.data.participant_id })) })
            .catch(e => { setError(e.message) })
    }, [API_PATH, res_id, userData, setUserData])

    const setActiveComponentHandler = e => {
        e.preventDefault()
        createParticipantInDB()
        setActiveComponent("Introduction")
    }

    const renderLandingPage = () => {
        return (<>
            <div id="heartily-welcome">
                <h4>{t("App.welcome")},</h4>
                <h2><b>{userData.name}</b></h2>
            </div>
            <h4><b>{t("Home.find_your_strengths")}</b></h4>
            <div id='show_video' className='py-2'>
                <iframe src="https://player.vimeo.com/video/910436103" className='my-3' width="640" height="360" title='video_oms' frameBorder="0"></iframe>
            </div>
            <button className='btn btn-primary btn-start' onClick={setActiveComponentHandler}>{t("App.btn_start")}</button>
        </>)
    }

    return (
        <div id='main-text' className='col-lg-9 m-3 text-center d-flex flex-column align-items-center'>
            {!error ? <>
                {!loading ?
                    renderLandingPage()
                    : <h4>{t("App.loading")}</h4>
                }
            </> : <>
                <h4 className='m-3'>{t('Home.applicant_error')}</h4>
                <p>{error}</p>
            </>}
        </div >
    )
}

export default Home
